import React, { useState } from 'react'
import { Col,  Row } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle, faPauseCircle, faPlus } from '@fortawesome/free-solid-svg-icons';
import Waveform from './waveform';

interface IBookMarkProps {
	src: any;
	handlePositionChange: any;
	handleReadyHandler: any;
	handleAddBookmark: any;
  id: string;
}

const formatTime = (seconds: number): string => {
	if (!seconds || isNaN(seconds) || seconds < 0) return "0:00";
	const totalSeconds = Math.floor(seconds);
	const hrs = Math.floor(totalSeconds / 3600);
	const mins = Math.floor((totalSeconds % 3600) / 60);
	const secs = totalSeconds % 60;
	const paddedSecs = secs.toString().padStart(2, "0");
	if (hrs > 0) {
		const paddedMins = mins.toString().padStart(2, "0");
		return `${hrs}:${paddedMins}:${paddedSecs}`;
	}
	return `${mins}:${paddedSecs}`;
};

const  BookMarkAudio: React.SFC <IBookMarkProps> = ({
  src, handlePositionChange, handleReadyHandler,  handleAddBookmark, id }) => {

	const [playing, setPlaying] = useState(false);
	const [currentTime, setCurrentTime] = useState(0);
	const [duration, setDuration] = useState(0);

	const handlePlayCallBack = (value: boolean) => {
		setPlaying(value)
	}

	const handlePosition = (position: number) => {
		setCurrentTime(position);
		handlePositionChange?.(position);
	}

	const handleDuration = (d: number) => {
		setDuration(d);
	}

    return (
      <div>
        <Row className='wave-con'>
          <Col lg="2" data-testid="playOrPause">
            {!playing && (
				<FontAwesomeIcon data-testid="playIcon" className='footer-box-icon-big-play' icon={faPlayCircle} data-bs-toggle="tooltip" data-bs-placement="bottom" title="Listen" onClick={() => { setPlaying(!playing); }} />
            )}
            {playing && (
				<FontAwesomeIcon data-testid="pauseIcon" className='footer-box-icon-big-play' icon={faPauseCircle} data-bs-toggle="tooltip" data-bs-placement="bottom" title="Listen" onClick={() => { setPlaying(!playing); }} />
            )}
          </Col>
		 <Col className='wave-center' data-testid="addBookMarkAndWave">
			<FontAwesomeIcon data-testid="addBookmarkIcon" className='footer-box-icon-big-plus' data-bs-toggle="tooltip" data-bs-placement="bottom" title="Add Bookmark" icon={faPlus} onClick={() => { handleAddBookmark(); }} />
			<div data-testid="waveFormOuterContainer"><Waveform data-testid="waveFormTest" src={src} onPositionChange={handlePosition} onReady={handleReadyHandler} onDurationChange={handleDuration} isPlay={playing} id={id} callback={handlePlayCallBack} /></div>
			<div className='audio-time-display' data-testid="audioTimeDisplay" style={{ textAlign: 'left', marginTop: '8px', fontSize: '14px', fontWeight: 500 }}>
				<span data-testid="audioCurrentTime">{formatTime(currentTime)}</span>
				<span> / </span>
				<span data-testid="audioDuration">{formatTime(duration)}</span>
			</div>
         </Col>
        </Row>
      </div>
    )
  }
export default BookMarkAudio;
